import { createRecallGateController } from './recallGateController.js';

/**
 * createRecallInputWire — Live B-key recall gate for InputController (AR-05).
 */
export function createRecallInputWire({ getMapId }) {
  const gate = createRecallGateController({ getMapId });

  function onRecallAttempt(entity) {
    return gate.tryRecall(entity);
  }

  return { onRecallAttempt };
}
